import React, { useState } from "react";
import "../../../assets/css/admin/Notifications.css";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

const Notifications = () => {
  const [filter, setFilter] = useState("all");
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: "info",
      title: "New student registration",
      message: "Ahmed Khan has registered for Full Stack Development course",
      time: "5 mins ago",
      read: false,
      icon: "user",
    },
    {
      id: 2,
      type: "success",
      title: "Course completion",
      message: "Sara Ali finished React Guide with 95% score",
      time: "1 hour ago",
      read: false,
      icon: "check",
    },
    {
      id: 3,
      type: "warning",
      title: "System maintenance scheduled",
      message: "Scheduled maintenance on Jan 15, 2025 at 2:00 AM PST",
      time: "2 hours ago",
      read: false,
      icon: "alert",
    },
    {
      id: 4,
      type: "info",
      title: "New mentor application received",
      message:
        "Dr. Kamran Siddiqui applied for Cloud Computing mentor position",
      time: "3 hours ago",
      read: true,
      icon: "user",
    },
    {
      id: 5,
      type: "success",
      title: "Payment received",
      message: "Hassan Raza completed payment for Pro subscription ($99.99)",
      time: "4 hours ago",
      read: true,
      icon: "dollar",
    },
    {
      id: 6,
      type: "error",
      title: "Failed quiz attempt",
      message:
        "Multiple students reported issues with JavaScript Advanced quiz",
      time: "5 hours ago",
      read: true,
      icon: "x",
    },
    {
      id: 7,
      type: "info",
      title: "New course uploaded",
      message: 'Mentor Ali Ahmad uploaded "Advanced React Patterns" course',
      time: "6 hours ago",
      read: true,
      icon: "book",
    },
    {
      id: 8,
      type: "success",
      title: "Milestone achieved",
      message: "Platform reached 1000+ active students this month",
      time: "1 day ago",
      read: true,
      icon: "trophy",
    },
  ]);

  const unreadCount = notifications.filter((n) => !n.read).length;

  const markAsRead = (id) => {
    setNotifications(
      notifications.map((n) => (n.id === id ? { ...n, read: true } : n)),
    );
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map((n) => ({ ...n, read: true })));
  };

  const deleteNotification = (id) => {
    setNotifications(notifications.filter((n) => n.id !== id));
  };

  const filteredNotifications = notifications.filter((n) => {
    if (filter === "all") return true;
    if (filter === "unread") return !n.read;
    return n.type === filter;
  });

  const getIcon = (iconType) => {
    const icons = {
      user: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      ),
      check: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      ),
      alert: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      ),
      dollar: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <line x1="12" y1="1" x2="12" y2="23"></line>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
        </svg>
      ),
      x: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      ),
      book: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
        </svg>
      ),
      trophy: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
          <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
          <path d="M4 22h16"></path>
          <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
          <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
          <path d="M18 2H6v7a6 6 0 0 0 12 0V2z"></path>
        </svg>
      ),
    };
    return icons[iconType] || icons.user;
  };

  return (
    <AdminLayout>
      <div className="notifications-container">
        {/* Header */}
        <div className="notifications-header">
          <div>
            <h2>Notifications</h2>
            <p className="notifications-subtitle">
              Stay updated with all platform activities
            </p>
          </div>
          <div className="header-actions">
            {unreadCount > 0 && (
              <button className="mark-all-read-btn" onClick={markAllAsRead}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Mark all as read
              </button>
            )}
            {/* <button className="def-martins-btn">Def Martins</button> */}
          </div>
        </div>

        {/* Stats Bar */}
        <div className="notifications-stats">
          <div className="stat-item">
            <span className="stat-label">Total</span>
            <span className="stat-value">{notifications.length}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Unread</span>
            <span className="stat-value highlight">{unreadCount}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Today</span>
            <span className="stat-value">4</span>
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="notifications-filters">
          <button
            className={`filter-btn ${filter === "all" ? "active" : ""}`}
            onClick={() => setFilter("all")}
          >
            All
          </button>
          <button
            className={`filter-btn ${filter === "unread" ? "active" : ""}`}
            onClick={() => setFilter("unread")}
          >
            Unread
            {unreadCount > 0 && (
              <span className="filter-badge">{unreadCount}</span>
            )}
          </button>
          <button
            className={`filter-btn ${filter === "info" ? "active" : ""}`}
            onClick={() => setFilter("info")}
          >
            Info
          </button>
          <button
            className={`filter-btn ${filter === "success" ? "active" : ""}`}
            onClick={() => setFilter("success")}
          >
            Success
          </button>
          <button
            className={`filter-btn ${filter === "warning" ? "active" : ""}`}
            onClick={() => setFilter("warning")}
          >
            Warning
          </button>
          <button
            className={`filter-btn ${filter === "error" ? "active" : ""}`}
            onClick={() => setFilter("error")}
          >
            Error
          </button>
        </div>

        {/* Notifications List */}
        <div className="notifications-list">
          {filteredNotifications.length === 0 ? (
            <div className="empty-state">
              <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
              <h3>No notifications found</h3>
              <p>You're all caught up! Check back later for updates.</p>
            </div>
          ) : (
            filteredNotifications.map((notification) => (
              <div
                key={notification.id}
                className={`notification-item ${
                  notification.read ? "read" : "unread"
                } ${notification.type}`}
              >
                <div className={`notification-icon ${notification.type}`}>
                  {getIcon(notification.icon)}
                </div>

                <div className="notification-content">
                  <div className="notification-header-row">
                    <h4>{notification.title}</h4>
                    <span
                      className={`notification-type-badge ${notification.type}`}
                    >
                      {notification.type}
                    </span>
                  </div>
                  <p>{notification.message}</p>
                  <span className="notification-time">{notification.time}</span>
                </div>

                <div className="notification-actions">
                  {!notification.read && (
                    <button
                      className="action-btn mark-read"
                      onClick={() => markAsRead(notification.id)}
                      title="Mark as read"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </button>
                  )}
                  <button
                    className="action-btn delete"
                    onClick={() => deleteNotification(notification.id)}
                    title="Delete notification"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Pagination */}
        {filteredNotifications.length > 0 && (
          <div className="notifications-pagination">
            <button className="pagination-btn">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
              Previous
            </button>
            <div className="pagination-info">
              <span className="page-number active">1</span>
              <span className="page-number">2</span>
              <span className="page-number">3</span>
            </div>
            <button className="pagination-btn">
              Next
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default Notifications;
